import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../utils/api';
import { toast } from 'react-toastify';

// Async thunk for forgot password
export const forgotPasswordThunk = createAsyncThunk(
    'forgotPassword/forgotPasswordThunk',
    async (email, { rejectWithValue }) => {
        try {
            const response = await api.forgotPassword({ email });
            toast.success(response.data?.data.message);
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Failed to request password reset';
            toast.error(errorMessage);
        }
    }
);

const forgotPasswordSlice = createSlice({
    name: 'forgotPassword',
    initialState: {
        loading: false,
        success: false,
        error: null,
    },
  
    extraReducers: (builder) => {
        builder
            .addCase(forgotPasswordThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(forgotPasswordThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.error = null;
            })
            .addCase(forgotPasswordThunk.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.error = action.payload;
            });
    }
});

export default forgotPasswordSlice.reducer;
